import type { ApprovalRequest } from '@/lib/types';
import { BucketShell } from './_BucketShell';

export interface UnknownViewProps {
  req: ApprovalRequest;
}

export function UnknownView({ req }: UnknownViewProps) {
  // Backfilled rows whose payload couldn't be classified into a v1 bucket.
  // Surface the raw payload JSON inside the standard shell so triage has
  // everything available without crashing the dispatcher.
  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-neutral-300 bg-neutral-50 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-neutral-700">
          Unclassified row
        </p>
        <p className="mt-4 text-sm text-neutral-700">
          This request was migrated from a legacy bucket and could not be auto-classified.
          The raw payload is shown below for triage.
        </p>
        <pre className="mt-12 max-h-[320px] overflow-auto rounded-md border border-neutral-200 bg-neutral-0 p-12 text-xs text-neutral-800">
          {JSON.stringify(req.payload ?? {}, null, 2)}
        </pre>
      </section>
    </BucketShell>
  );
}
